import { Link } from "react-router-dom";

const TabletCard = ({ tablet }) => {
  return (
    <Link
      to={`/categories/tablettes/${tablet.id}`}
      className="bg-white rounded-2xl shadow hover:shadow-xl transition overflow-hidden"
    >
      {/* Image */}
      <div className="h-48 bg-white flex items-center justify-center p-3">
        <img
          src={tablet.image}
          alt={tablet.name}
          className="max-h-full object-contain"
        />
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="text-xl font-semibold">{tablet.name}</h3>
        <p className="text-gray-600 text-sm mt-1">
          {tablet.category}
        </p>
        <p className="mt-3 font-bold text-primary">
          {tablet.price} €
        </p>
      </div>
    </Link>
  );
};

export default TabletCard;